
    <fieldset class="section">
      <div class="container" [ngStyle]="style">
        <ng-content></ng-content>
      </div>
    </fieldset>
  


// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵd.html